import {
  createAction,
  CustomStoreAddOn, FilterCollectionStore,
  on,
  SOFTLINE_STORE_ENTITY_SERVICE, SortCollectionStore,
  StoreBuilder,
  SyncedRemoteCollectionStore
} from '@softline/core';
import {RetourenBewe} from '../data/retouren-bewe';
import {lastValueFrom} from 'rxjs';

const collectionStore = SyncedRemoteCollectionStore.create<RetourenBewe>()
type State = typeof collectionStore.feature.initialState;

const getters = {}
const mutations = {}
const actions = {
  createOrUpdate: createAction<State, Omit<RetourenBewe, 'id'>, RetourenBewe>('mdeRetouren/createOrUpdate')
}

export const RetourenBeweStoreExtension: CustomStoreAddOn<
  State,
  typeof mutations,
  typeof getters,
  typeof actions
> = {
  getters,
  mutations,
  actions,
  feature: {
    initialState: collectionStore.feature.initialState,
    getters: [],
    mutations: [],
    actions: [
      on(actions.createOrUpdate, async ({ commit, featureName, params, injector }) => {
          const service = injector.get(SOFTLINE_STORE_ENTITY_SERVICE);
          const result = await lastValueFrom(service.create(params));
          commit(featureName, collectionStore.mutations.addOrUpdate, result);
          return result
      })
    ],
  }
}

export const RetourenBeweStore = new StoreBuilder(collectionStore)
  .add(RetourenBeweStoreExtension)
  .add(FilterCollectionStore.create<RetourenBewe>())
  .add(SortCollectionStore.create<RetourenBewe>())
  .value
